const { toInt, toString } = require('@/functions/transform');

class ItemInstanceOrderMap {
    constructor() {
        /**
         * @type {string}
         */
        this.itemInstanceRef = undefined;

        /**
         * @type {number}
         */
        this.orderID = undefined;

        /**
         * @type {number}
         */
        this.itemInstanceID = undefined;
    }

    getHydrationMap() {
        return {
            itemInstanceRef: toString,
            orderID: toInt,
            itemInstanceID: toInt,
        };
    }
}

module.exports = ItemInstanceOrderMap;
